export const FACEBOOK = 'facebook';
export const INSTAGRAM = 'instagram';
export const LINKEDIN = 'linkedin';
export const MAIL = 'mail';
